import { IPaginatedResponse, IResponse } from "../../model";
import ServiceBase from "../../servicebase";
import { IPaisRequisito } from "./model";

export default class PaisRequisitoService extends ServiceBase {
  get = (data:{ codigo?: number }) : Promise<IResponse<IPaisRequisito>> => 
    this.GetFetch<IResponse<IPaisRequisito>>('paisrequisito', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, codigo?: number, nombre?: string, region?: string, activo?: boolean }) : Promise<IPaginatedResponse<IPaisRequisito>> => 
    this.GetFetch<IPaginatedResponse<IPaisRequisito>>('paisrequisito/find', data);

  all = () : Promise<IResponse<IPaisRequisito[]>> => 
    this.GetFetch<IResponse<IPaisRequisito[]>>('paisrequisito/all', {});

  getNextCodigo = () : Promise<IResponse<number>> => 
    this.GetFetch<IResponse<number>>('paisrequisito/nextcodigo', {});

  upsert = (data:IPaisRequisito) : Promise<IResponse<IPaisRequisito>> => 
    this.PostFetch<IResponse<IPaisRequisito>>('paisrequisito', data);

  delete = (data:{ codigo:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('paisrequisito', data);
}
